import { store } from '@/store';
import api from '@api/Api';

export default {

    getUser() {
        return api().get(`/users/me`).then((response) => {
            store.commit('setUser', response.data.data);
            return response;
        });
    },

    updateUser(params) {
        return api().put(`/users/me`, params).then((response) => {
            store.commit('setUser', response.data.data);
            return response;
        });
    },

    updateUserSettings(params) {
        return api().put(`/users/me/settings`, params).then((response) => {
            store.commit('setUser', response.data.data);
            return response;
        });
    },

    updatePassword(params) {
        return api().put(`/users/me/password`, params);
    },

    verifyEmail() {
        return api().post('/users/me/verify-email');
    },

    getSubscription() {
        return api().get(`/users/me/subscription`);
    },

    deleteUser() {
        return api().delete(`/users/me`);
    },

    /**
     * Spaces
     */

    createSpace(params) {
        return api().post('/users/me/spaces', params).then((response) => {
            store.commit('setUser', response.data.data);
            return response;
        });
    },

    getSpaces(params) {
        return api().get('/users/me/spaces', { 'params': params });
    },

    /**
     * Projects
     */

    createProject(params) {
        return api().post('/users/me/projects', params).then((response) => {
            store.commit('setUser', response.data.data);
            store.commit('setLocationId', null);
            return response;
        });
    },

    selectProject(id) {
        return api().post(`users/me/projects/${id}`).then((response) => {
            store.commit('setUser', response.data.data);
            store.commit('setLocationId', null);
            return response;
        });
    },

    getProjects() {
        return api().get(`users/me/projects`);
    },

    /**
     * Agency
     */

    createAgency(params) {
        return api().post('/users/me/agency', params).then((response) => {
            store.commit('setUser', response.data.data);
            return response;
        });
    },

}
